import { makeStyles } from '@material-ui/core';
import { getInverseSurface } from 'UI/theme/darkTones';

const TABLE_Z_INDEX = {
  header: 1,
  stickyColumn: 2,
  stickyColumnHeaderCell: 3
};
const MIN_WIDTH = {
  defaultCell: 100,
  stickyColumn: 250
};
export const useStyles = makeStyles(theme => {
  const borderBottom = `1px solid ${theme.palette.grey[300]}`;
  const boldText = theme.typography.fontWeightBold;
  const mediumText = theme.typography.fontWeightMedium;

  const stickyBase = {
    position: 'sticky',
    backgroundColor: theme.palette.background.paper,
    zIndex: TABLE_Z_INDEX.column
  };

  const teamRowBase = {
    border: 'none !important',
    color: theme.palette.common.white,
    fontWeight: mediumText,
    padding: 0
  };

  return {
    boxCopyWrapper: {
      display: 'flex',
      alignItems: 'flex-start',
      marginBottom: theme.spacing(2),
      '& ul': {
        margin: theme.spacing(0)
      }
    },
    loadingRow: {
      width: '100%',
      height: '30vh',
      verticalAlign: 'initial'
    },
    tableContainer: {
      borderRadius: theme.spacing(1),
      boxSizing: 'border-box',
      maxHeight: '85vh',
      overflow: 'auto',
      position: 'relative',
      width: '100%'
    },
    stickyHeader: {
      ...stickyBase,
      top: 0,
      textAlign: 'right',
      backgroundColor: theme.palette.grey[400],
      minWidth: MIN_WIDTH.defaultCell,
      padding: theme.spacing(1, 1, 0, 1),
      verticalAlign: 'top',
      zIndex: TABLE_Z_INDEX.header
    },
    stickyColumn: {
      ...stickyBase,
      left: 0,
      minWidth: MIN_WIDTH.stickyColumn,
      paddingLeft: `${theme.spacing(1)}px !important`,
      textAlign: 'left !important',
      borderBottom
    },
    bold: {
      fontWeight: boldText
    },
    teamHeaderCell: {
      backgroundColor: theme.palette.grey[400],
      zIndex: TABLE_Z_INDEX.stickyColumnHeaderCell
    },
    headerInnerDayCell: {
      backgroundColor: `${theme.palette.grey[300]} !important`
    },
    expandableButton: {
      padding: theme.spacing(1),
      verticalAlign: 'bottom',
      cursor: 'pointer'
    },
    commonCell: {
      borderBottom
    },
    cell: {
      padding: 0,
      textAlign: 'right'
    },
    formattedText: {
      whiteSpace: 'pre'
    },
    recruiter: {
      paddingLeft: `${theme.spacing(3)}px !important`
    },
    gpacRow: {
      ...teamRowBase,
      background: theme.palette.brandColors?.FPRed
    },
    regionalRow: {
      ...teamRowBase,
      background: getInverseSurface(theme, theme.palette.grey[600])
    },
    rowColor: {
      '&:hover': {
        backgroundColor: `${theme.palette.grey[200]} !important`,
        '& td': {
          backgroundColor: `${theme.palette.grey[200]} !important`
        }
      }
    }
  };
});
